import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { Subscription } from "rxjs";
import { TranslocoService } from "@ngneat/transloco";
import { DOCUMENT } from "@angular/common";

declare var gtag;

@Component({
  selector: "v2m-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  title = "video2manual";
  topPosition = true;
  subscription: Subscription;

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private translocoService: TranslocoService
  ) {
    router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        filter((_) => !window.location.host.startsWith("localhost"))
      )
      .subscribe((event: NavigationEnd) => {
        gtag("config", "UA-18714603-2", {
          page_path: event.urlAfterRedirects,
        });
      });

    translocoService.langChanges$.subscribe((lang) =>
      console.log("Changed language to " + lang)
    );
  }

  ngOnInit(): void {
    this.subscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (window.pageYOffset > 0) {
          window.scrollTo(0, 1);
        }
        const menuToggle = document.getElementById(
          "menu-toggle-checkbox"
        ) as HTMLInputElement;
        if (menuToggle) menuToggle.checked = false;
      });

    window.addEventListener("scroll", this.scrollEvent, true);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();

    window.removeEventListener("scroll", this.scrollEvent, true);
  }

  scrollEvent = (event: any) => {
    this.topPosition = window.scrollY === 0;
  };

  switchToGerman(): void {
    this.translocoService.setActiveLang("de");
  }

  switchToEnglish(): void {
    this.translocoService.setActiveLang("en");
  }
}
